export const WHITE = '#ffffff';
export const BLACK = '#141414';

export const BLUE_DARKEN = '#04589b';
export const BLUE = '#066FC2';
export const BLUE_LIGHTEN = '#0e90f7';

export const GREY_DARKEN = '#666666';
// $grey: #808080;
export const GREY = '#575757';
export const GREY_LIGHTEN = '#D2D2D2';

export const GREEN_DARKEN = '#00803a';
export const GREEN = '#00A149';
export const GREEN_LIGHTEN = '#00a149';

export const MOBILE = '480px';
export const TABLET = '767px';
export const NETBOOK = '991px';
export const NOTEBOOK = '1280px';
export const LARGE = '1690px';
